import type { RecruitmentModule } from '@bc-library/interface'

export const RECRUITMENT_SETTING_ACCESS_KEYS = [
  'settingsEvaluationsAccess',
  'settingsWebsitesAccess',
  'settingsMailTemplatesAccess',
  'settingsOfficesAccess',
  'settingsRejectionAccess',
  'settingsWithdrawalAccess',
  'settingsCustomQuestionsAccess',
  'settingsHowDidYouFindUsAccess',
  'settingsTagsAccess',
  'settingsAcknowledgmentAccess',
] as const

export type RecruitmentSettingAccessKey = typeof RECRUITMENT_SETTING_ACCESS_KEYS[number]

export const hasAnyRecruitmentSettingsAccess = (recruitment?: RecruitmentModule) => {
  if (!recruitment)
    return false
  // « Tous les paramètres » (stored as settingsAcess) opens every section, as in the other modules
  if (recruitment.settingsAcess)
    return true
  return RECRUITMENT_SETTING_ACCESS_KEYS.some(key => recruitment[key])
}

export const hasRecruitmentSettingAccess = (
  recruitment: RecruitmentModule | undefined,
  key: RecruitmentSettingAccessKey,
) => {
  if (!recruitment)
    return false
  if (recruitment.settingsAcess)
    return true
  return !!recruitment[key]
}
